import { InjectionToken } from '@angular/core';

import { AppConfig } from '®shared/config';

export const LAUNCH_METHOD = new InjectionToken<string>(
  'app.context.launchMethod',
);

export enum LaunchMethod {
  DIRECT = 'direct',
  LTI = 'lti',
}

export function getLaunchMethod(appConfig: AppConfig): LaunchMethod {
  return appConfig.isAnLti1p0EmbeddedSession
    ? LaunchMethod.LTI
    : LaunchMethod.DIRECT;
}

export const LaunchMethodFactoryProvider = {
  provide: LAUNCH_METHOD,
  useFactory: getLaunchMethod,
  deps: [AppConfig],
};
